// components/CookieBanner.tsx
import React from "react";
import { useConsent } from "../../context/cookieConsent";
import "../../components/CookieBanner/cookie.css";

export const CookieBanner = () => {
  const { consentGiven, acceptCookies, rejectCookies } = useConsent();

  // Don't show if already consented
  if (consentGiven) return null;

  return (
    <div className="cookie-banner">
      <div className="cookie-content">
        <h3>We use cookies</h3>
        <p>
          This website uses cookies to improve your experience. We only use
          analytics cookies to understand usage patterns.
        </p>
        <div className="cookie-buttons">
          <button onClick={acceptCookies} className="accept-btn">
            Accept All
          </button>
          <button onClick={rejectCookies} className="reject-btn">
            Reject Analytics
          </button>
        </div>
      </div>
    </div>
  );
};
